import { render, staticRenderFns } from "./mecanismo-comunicacion.vue?vue&type=template&id=5267531a&"
import script from "./mecanismo-comunicacion.vue?vue&type=script&lang=js&"
export * from "./mecanismo-comunicacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports